export default function (url) {
  return process.env.NODE_ENV === 'test' ? `http://localhost${url}` : url;
}



// WEBPACK FOOTER //
// ./src/utils/url.js